import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auditoria',
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.css'],
})
export class AuditoriaComponent implements OnInit {
  activeTab: 'bonos' | 'login' | 'sp' = 'bonos';
  showLoading = false;

  currentPage = 1;
  pageSize = 20;
  totalItems = 0;
  totalPages = 0;

  dataList: any[] = [];
  selectedItem: any = null;
  stats: any = {};

  filterForm: FormGroup;
  modalRef: BsModalRef;
  mapModalRef: BsModalRef;
  mapItem: any = null;
  mapUrl: SafeResourceUrl = null;
  private readonly MAPS_KEY = 'AIzaSyBnttQrcmcaLKv_ovSy1uklF6gL90afOvM';

  constructor(
    private http: HttpClient,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer
  ) {}

  private today(): string {
    const d = new Date();
    return d.toISOString().split('T')[0];
  }

  ngOnInit() {
    const hoy = this.today();
    this.filterForm = new FormGroup({
      desde: new FormControl(hoy),
      hasta: new FormControl(hoy),
      device_type: new FormControl(''),
      location_source: new FormControl(''),
      search: new FormControl(''),
      outcome: new FormControl(''),
      event_type: new FormControl(''),
      event_subtype: new FormControl(''),
      medic: new FormControl(''),
      patient_cc: new FormControl(''),
      user: new FormControl(''),
      qr_source: new FormControl(''),
    });
    this.loadStats();
    this.loadData();
  }

  switchTab(tab: 'bonos' | 'login' | 'sp') {
    this.activeTab = tab;
    this.currentPage = 1;
    const hoy = this.today();
    this.filterForm.reset({
      desde: hoy,
      hasta: hoy,
      device_type: '',
      location_source: '',
      search: '',
      outcome: '',
      event_type: '',
      event_subtype: '',
      medic: '',
      patient_cc: '',
      user: '',
      qr_source: '',
    });
    this.loadStats();
    this.loadData();
  }

  private tabUrl(kind: 'data' | 'stats' | 'export'): string {
    const map = {
      bonos: {
        data: environment.Api_audit_bonos,
        stats: environment.Api_audit_bonos_stats,
        export: environment.Api_audit_bonos_export,
      },
      login: {
        data: environment.Api_audit_login,
        stats: environment.Api_audit_login_stats,
        export: environment.Api_audit_login_export,
      },
      sp: {
        data: environment.Api_audit_sp_contact,
        stats: environment.Api_audit_sp_contact_stats,
        export: environment.Api_audit_sp_contact_export,
      },
    };
    return map[this.activeTab][kind];
  }

  loadStats() {
    const params = this.buildParams(false);

    this.http.get(this.tabUrl('stats'), { params }).subscribe({
      next: (res: any) => {
        this.stats = res;
      },
      error: () => {
        this.stats = {};
      },
    });
  }

  loadData() {
    this.showLoading = true;
    const params = this.buildParams(true);

    this.http.get(this.tabUrl('data'), { params }).subscribe({
      next: (res: any) => {
        this.dataList = res.results || [];
        this.totalItems = res.total || 0;
        this.totalPages = res.total_pages || Math.ceil((res.total || 0) / this.pageSize);
        this.showLoading = false;
      },
      error: () => {
        this.dataList = [];
        this.showLoading = false;
      },
    });
  }

  buildParams(withPagination: boolean): HttpParams {
    const f = this.filterForm.value;
    let params = new HttpParams();

    if (withPagination) {
      params = params
        .set('page', this.currentPage.toString())
        .set('page_size', this.pageSize.toString());
    }

    if (f.desde) params = params.set('desde', f.desde);
    if (f.hasta) params = params.set('hasta', f.hasta);
    if (f.device_type) params = params.set('device_type', f.device_type);
    if (f.location_source) params = params.set('location_source', f.location_source);
    if (f.search) params = params.set('search', f.search);

    if (this.activeTab === 'bonos') {
      if (f.outcome) params = params.set('outcome', f.outcome);
      if (f.medic) params = params.set('medic', f.medic);
      if (f.patient_cc) params = params.set('patient_cc', f.patient_cc);
      if (f.qr_source) params = params.set('qr_source', f.qr_source);
    } else if (this.activeTab === 'login') {
      if (f.event_type) params = params.set('event_type', f.event_type);
      if (f.user) params = params.set('user', f.user);
    } else {
      if (f.outcome) params = params.set('outcome', f.outcome);
      if (f.event_subtype) params = params.set('event_subtype', f.event_subtype);
      if (f.medic) params = params.set('medic', f.medic);
      if (f.patient_cc) params = params.set('patient_cc', f.patient_cc);
    }

    return params;
  }

  applyFilter() {
    this.currentPage = 1;
    this.loadStats();
    this.loadData();
  }

  clearFilter() {
    const hoy = this.today();
    this.filterForm.reset({
      desde: hoy,
      hasta: hoy,
      device_type: '',
      location_source: '',
      search: '',
      outcome: '',
      event_type: '',
      event_subtype: '',
      medic: '',
      patient_cc: '',
      user: '',
      qr_source: '',
    });
    this.currentPage = 1;
    this.loadStats();
    this.loadData();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.loadData();
  }

  openDetail(item: any, template: TemplateRef<any>) {
    this.selectedItem = item;
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: true,
      ignoreBackdropClick: false,
    });
  }

  closeModal() {
    if (this.modalRef) this.modalRef.hide();
  }

  openMapModal(template: TemplateRef<any>, rowItem?: any) {
    const target = rowItem || this.selectedItem;
    if (!target || !target.latitude || !target.longitude) return;
    this.mapItem = target;
    const url = `https://www.google.com/maps/embed/v1/place?key=${this.MAPS_KEY}&q=${target.latitude},${target.longitude}&zoom=16`;
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.mapModalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: true,
      ignoreBackdropClick: false,
    });
  }

  closeMapModal() {
    if (this.mapModalRef) this.mapModalRef.hide();
  }

  exportCsv() {
    const params = this.buildParams(false);
    const filenames = {
      bonos: 'audit_bonos.csv',
      login: 'audit_login.csv',
      sp: 'audit_sp_contact.csv',
    };

    this.http.get(this.tabUrl('export'), { params, responseType: 'blob' }).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = filenames[this.activeTab];
        a.click();
        URL.revokeObjectURL(objectUrl);
      },
      error: () => {},
    });
  }

  outcomeLabel(outcome: string): string {
    const map: any = { success: 'Exitoso', overlimit: 'Límite', failed: 'Fallido' };
    return map[outcome] || outcome;
  }

  outcomeClass(outcome: string): string {
    const map: any = {
      success: 'badge-success',
      overlimit: 'badge-purple',
      failed: 'badge-danger',
    };
    return map[outcome] || '';
  }

  spOutcomeClass(outcome: string): string {
    const map: any = { success: 'badge-success', failed: 'badge-danger' };
    return map[outcome] || '';
  }

  spSubtypeClass(subtype: string): string {
    const map: any = { cellphone_update: 'badge-blue', email_update: 'badge-purple' };
    return map[subtype] || '';
  }

  qrSourceLabel(type: string): string {
    const map: any = { static: 'Estático', dynamic: 'Dinámico' };
    return map[type] || type;
  }

  qrSourceClass(type: string): string {
    const map: any = { static: 'badge-blue', dynamic: 'badge-purple' };
    return map[type] || '';
  }

  eventLabel(event: string): string {
    const map: any = { login: 'Login', logout: 'Logout', login_failed: 'Fallido' };
    return map[event] || event;
  }

  eventClass(event: string): string {
    const map: any = {
      login: 'badge-success',
      logout: 'badge-blue',
      login_failed: 'badge-danger',
    };
    return map[event] || '';
  }

  deviceIcon(item: any): string {
    const type = (item.device_type || '').toLowerCase();
    if (type === 'mobile') return '📱';
    if (type === 'tablet') return '📟';
    return '💻';
  }

  get pageNumbers(): number[] {
    const total = this.totalPages;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const current = this.currentPage;
    const pages = new Set<number>();
    pages.add(1);
    pages.add(total);
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      pages.add(i);
    }
    return Array.from(pages).sort((a, b) => a - b);
  }

  get showingFrom(): number {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get showingTo(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalItems);
  }

  statVal(v: any): string | number {
    return v !== null && v !== undefined ? v : '—';
  }

  dv(v: any): string {
    return (v !== null && v !== undefined && v !== '') ? String(v) : '—';
  }

  osDisplay(item: any): string {
    const name = this.dv(item.os_name) === '—' ? '' : item.os_name;
    const ver  = this.dv(item.os_version) === '—' ? '' : item.os_version;
    const result = [name, ver].filter(Boolean).join(' ');
    return result || '—';
  }

  copyToken(token: string) {
    const nav = navigator as any;
    if (nav.clipboard) {
      nav.clipboard.writeText(token).catch(() => {});
    }
  }

  accuracyDisplay(v: any): string {
    if (!v) return '—';
    return parseFloat(v).toFixed(1) + ' m';
  }
}
